<template>
    <div>
        <!--Banner Start Here -->
        <section class="banner2">
            <div class="container clearfix">
                <div class="banner__caption2">
                    <h1>Quizz</h1><br>
                </div>
            </div>
        </section>
        <!--Banner End Here -->
            <!-- Background container -->
            <div id="background-container" class="background-container">
                <div id="background-output" class="background-output"></div>
                <div id="vignette" class="background-vignette"></div>
                <div id="noise" class="background-noise"></div>
            </div>
        <div class="container" v-show="questionIndex === quiz.questions.length && flag_end !== true">
            <div class="row">
                <div class="col-md-12 centered">
                    <p>Tu veux garder contact et suivre nos aventures.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">&nbsp;</div>
                <div class="col-md-4 centered">
                    <div class="form-group">
                        <div class="icon-addon addon-md">
                            <input v-validate="'email'" type="text" placeholder="Email *" class="form-control" id="email" v-model="user.email" name="email" >
                            <label for="email" class="fa fa-envelope" rel="tooltip" title="Email"></label>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">&nbsp;</div>
            </div>
            <div class="row">
                <div class="col-md-4">&nbsp;</div>
                <div class="col-md-4 centered">
                    <div class="form-group">
                        <div class="icon-addon addon-md">
                            <input type="text" placeholder="Nom" class="form-control" id="full_name" v-model="user.full_name" >
                            <label for="full_name" class="fa fa-user" rel="tooltip" title="Nom complet"></label>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">&nbsp;</div>
            </div>
            <div class="row">
                <div class="col-md-12 centered">
                    <div class="form-check">
                        <small><u v-on:click="setEnd()" class="hand">Montre moi juste les réponses</u></small>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 centered">
                    &nbsp;
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <button class="btn btn-cred btn-lg btn-block" type="button" :disabled="user.email === '' || errors.has('email') " v-on:click="setEnd()">Voir les résultats! </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="container add-padding">
            <div class="row" v-show="questionIndex !== quiz.questions.length">
                <div class="col-md-12 centered countdown round"  >
                    <h4>{{ quiz.title }}</h4>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">&nbsp;</div>
            </div>
        <!-- index is used to check with current question index -->
            <div v-for="(question, index) in quiz.questions" class="row">
                <!-- Hide all questions, show only the one with index === to current question index -->

                <div v-show="index === questionIndex" class="col-md-8 frb-group">
<!-- ************************************ -->
                    <div class ="row">
                        <p class="col-md-12">Question {{questionIndex+1}}/{{quiz.questions.length}} : </p>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <h5 v-html="question.text"></h5>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">&nbsp;</div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-check frb frb-success" v-for="(response,count) in question.responses">
                                <input class="form-check-input" type="radio" 
                                    v-bind:value="response.score" 
                                    v-bind:name="radioId(index)" 
                                    v-bind:id="radioId(index+''+count)" 
                                    v-model="userResponses[index]"> 
                                <label  class="form-check-label" v-bind:for="radioId(index+''+count)" >
                                    <span class="frb-description"><h6>{{response.text}}</h6></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 clearfix">
                            <button v-if="questionIndex > 0" v-on:click="prev" class="btn btn-cred btn-round hand alignleft">
                                préc.
                            </button>
                            <button v-on:click="next" :disabled="userResponses[index] == null" class="btn btn-cred btn-round hand alignright">
                                suiv. 
                            </button>
                        </div>
                    </div>
<!-- ************************************ -->
                </div>
                <div v-show="index === questionIndex" class="col-md-4">
                    <img :src="question.img" class="img-responsive">
                </div>
            </div>
            <div class="row" v-show="flag_end !== false">
                <div class="col-md-12 centered">
                    <img :src="rank" class="img-medals">
                    <p class="countdown">
                    Total score: {{ score() }} / {{ quiz.questions.length * 2 }}
                    </p>
                </div>
            </div>
            <div class="row" v-show="flag_end !== false">
                <p class="col-md-12 centered">{{result}}</p>
            </div>
            <div class="row" v-show="flag_end !== false">
                <div class="col-md-12 centered">
                    Tu as aimé ? Fais le savoir en partageant <3.
                </div>
            </div>
            <div class="row" v-show="flag_end !== false">
                <div class="col-md-12 centered">
                  <!-- Your share button code -->
                    <div class="fb-share-button" :data-href="fb_link" data-layout="button_count" data-size="large" data-mobile-iframe="true"><a class="fb-xfbml-parse-ignore" target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Fchaperon.me%2F%23%2Fquizz&amp;src=sdkpreparse">Partager</a></div>
                </div>
            </div>
            <div class ="row">
                <div id="fb-root" class="col-md-12"></div>
            </div>
        </div>
    </div>
</div>

</template>

<script>

import quizzes from './resources/quizz.json'
// var mg = this.$mailgun.client({ username: 'api', key: process.env.MAILGUN_API_KEY })
export default {
  name: 'quizz',
  data () {
    return {
      fb_link: '',
      quizes: quizzes,
      quiz: null,
      // Store current question index
      questionIndex: 0,
      count: 0,
      userResponses: Array(quizzes[0].questions.length),
      result: '',
      rank: '',
      user: {full_name: '', email: '', age: '', job: '', gender: '', q_id: '', from: 'Quizz'},
      flag_end: false,
      disable_male: false,
      disable_female: false,
      toast_options: {position: 'bottom-right', duration: 5000, theme: 'primary', type: 'success', action: {text: 'FERMER', onClick: (e, toastObject) => { toastObject.goAway(0) }}},
      mg: this.$mailgun
    }
  },
  // The view will trigger these methods on click
  methods: {
    // Go to next question
    next: function () {
      window.scrollTo(0, 0)
      this.questionIndex++
    },
    // Go to previous question
    prev: function () {
      window.scrollTo(0, 0)
      this.questionIndex--
    },
    // Return "true" count in userResponses
    score: function () {
      var sum = 0
      for (var i = 0; i < this.questionIndex; i++) {
        sum += this.userResponses[i]
      }
      // Let display the conclusion
      if (sum < 5) {
        this.result = this.quiz.results[0].text
        this.rank = '/static/img/' + this.quiz.results[0].rank + '.png'
      } else if (sum >= 5 && sum <= 7) {
        this.result = this.quiz.results[1].text
        this.rank = '/static/img/' + this.quiz.results[1].rank + '.png'
      } else {
        this.result = this.quiz.results[2].text
        this.rank = '/static/img/' + this.quiz.results[2].rank + '.png'
      }
      return sum
    },
    radioId: function (id) {
      return 'radio-button-' + id
    },
    setGender: function (gender) {
      this.user.gender = gender
      if (this.user.gender === 'F') {
        this.disable_female = true
        this.disable_male = false
      } else if (this.user.gender === 'M') {
        this.disable_female = false
        this.disable_male = true
      } else {
        this.disable_female = false
        this.disable_male = false
      }
    },
    isNumber: function () {
      if (this.user.age && this.user.age.length > 1) {
        this.user.age = this.user.age.slice(0, 1)
      }
    },
    setEnd: function () {
      this.flag_end = true
      // Set the cookie
      if (this.user.email !== '' && this.user.email !== null) {
        this.$cookies.set('email_p', this.user.email, 'Infinity')
      }
      if (this.user.full_name !== '' && this.user.full_name !== null) {
        this.$cookies.set('full_name_p', this.user.full_name, 'Infinity')
      }
      if (this.user.age !== '' && this.user.age !== null) {
        this.$cookies.set('age_p', this.user.age, 'Infinity')
      }
      if (this.user.job !== '' && this.user.job !== null) {
        this.$cookies.set('job_p', this.user.job, 'Infinity')
      }
      if (this.user.gender !== '' && this.user.gender !== null) {
        this.$cookies.set('gender_p', this.user.gender, 'Infinity')
      }
      // you can call like this in your component
      this.$toasted.show('Merci ' + this.user.full_name + ' pour ta participation !', this.toast_options)
      // Send User information
      this.sendMail()
    },
    clearCookies: function () {
      // Clear cookies
      this.$cookies.remove('email_p')
      this.$cookies.remove('age_p')
      this.$cookies.remove('full_name_p')
      this.$cookies.remove('job_p')
      this.$cookies.remove('gender_p')
      // Reinit model
      this.user.email = ''
      this.user.age = ''
      this.user.full_name = ''
      this.user.job = ''
      this.user.gender = ''
      this.setGender(this.user.gender)
    },
    sendMail: function () {
      this.resource.save({}, {user: this.user, result: JSON.stringify(this.userResponses)}).then(function (response) {
        console.log('Success!:', response.data)
      }, function (error) {
        console.log('Error!:', error)
      })
    }
  },
  created: function () {
    // get cookies
    this.user.email = this.$cookies.get('email_p') ? this.$cookies.get('email_p') : ''
    this.user.age = this.$cookies.get('age_p') ? this.$cookies.get('age_p') : ''
    this.user.full_name = this.$cookies.get('full_name_p') ? this.$cookies.get('full_name_p') : ''
    this.user.job = this.$cookies.get('job_p') ? this.$cookies.get('job_p') : ''
    this.user.gender = this.$cookies.get('gender_p') ? this.$cookies.get('gender_p') : ''
    this.setGender(this.user.gender)
    // Retrieve Quizz number
    if (this.$route.params.id && (parseInt(this.$route.params.id) - 1) <= this.quizes.length) {
      this.quiz = this.quizes[this.$route.params.id - 1]
      this.user.q_id = this.quiz.id
      this.fb_link = 'https://chaperon.me/#/quizz/' + this.quiz.id
    } else {
      this.quiz = {id: 0} // Trick in order to initialize when quizz not found
    }

    if (this.quiz.id !== this.$route.params.id) {
      // path route
      this.$router.push({path: '/quizz'})
    }
  },
  mounted: function () {
    this.resource = this.$resource('mailer')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

</style>



// WEBPACK FOOTER //
// Quizz.vue?20164f65